import { create } from "zustand";
// using alternate approach right now not using this
const useViewStyle = create((set) => ({
  designLibraryView: "grid",
  setView: (view, from) => set({ [from]: view }),
  projectSpecificationView: "list",
  selectedMenu: "",
  setSelectedMenu: (menu, previous) =>
    set({ selectedMenu: menu, previousMenu: previous }),
  previousMenu: null,
  setPreviousMenu: (menu) => set({ previousMenu: menu }),
}));

export default useViewStyle;
